import React, { useRef } from 'react'
import { Link } from 'react-router-dom';
import './blog.css';
import ImageCard from './components/image-card/imagecard.jsx'
import MM1group from './components/posts/23-24/pictures/MM1group.jpg';
import MM1officer from './components/posts/23-24/pictures/MM1officer.jpg';
import Uberofficer from './components/posts/23-24/pictures/Uberofficer.jpg';
import Uberspeakers from './components/posts/23-24/pictures/Uberspeakers.jpg';
import Pinterest1 from './components/posts/23-24/pictures/Pinterest1.png';
import Pinterest2 from './components/posts/23-24/pictures/Pinterest2.png';
import Googlerecap1 from './components/posts/23-24/pictures/Googlerecap1.jpg';
import Googlerecap6 from './components/posts/23-24/pictures/Googlerecap6.jpg';
import ghc3 from './components/posts/23-24/pictures/ghc3.jpg';
import ghc1 from './components/posts/23-24/pictures/ghc1.jpg';
import f1 from './components/posts/23-24/pictures/f1.jpg';
import f3 from './components/posts/23-24/pictures/f3.jpg';
import dec1 from './components/posts/23-24/pictures/dec1.jpg';
import dec7 from './components/posts/23-24/pictures/dec7.jpg';
import slumber2 from './components/posts/23-24/pictures/slumber2.jpg';
import slumber6 from './components/posts/23-24/pictures/slumber6.jpg';
import wad1 from './components/posts/23-24/pictures/wad1.jpg';
import wad2 from './components/posts/23-24/pictures/wad2.jpg';
import PM1 from './posts/22-23/pictures/PM1.JPG';
import PM2 from './posts/22-23/pictures/PM2.JPG';
import PM3 from './posts/22-23/pictures/PM3.JPG';
import PM4 from './posts/22-23/pictures/PM4.JPG';
import bouquet1 from './posts/22-23/pictures/bouquet1.jpg';
import bouquet2 from './posts/22-23/pictures/bouquet2.jpg';
import bouquet3 from './posts/22-23/pictures/bouquet3.jpg';
import bouquet4 from './posts/22-23/pictures/bouquet4.jpg';
import bouquet5 from './posts/22-23/pictures/bouquet5.jpg';
import bouquet6 from './posts/22-23/pictures/bouquet6.jpg';
import prep1 from './posts/22-23/pictures/prep1.jpeg';
import prep2 from './posts/22-23/pictures/prep2.jpeg';
import wir1 from './posts/22-23/pictures/wir1.JPG';
import wir2 from './posts/22-23/pictures/wir2.JPG';
import wir3 from './posts/22-23/pictures/wir3.JPG';
import wad from './posts/22-23/pictures/wad.jpg';
import equity1 from './posts/22-23/pictures/equity1.jpg';
import equity2 from './posts/22-23/pictures/equity2.jpg';
import bowl1 from './posts/22-23/pictures/bowl1.jpg';
import bowl2 from './posts/22-23/pictures/bowl2.jpg';
import bowl3 from './posts/22-23/pictures/bowl3.jpg';
import cookies1 from './posts/22-23/pictures/cookies1.jpg';
import cookies2 from './posts/22-23/pictures/cookies2.jpg';
import google1 from './posts/22-23/pictures/google1.JPG';
import google2 from './posts/22-23/pictures/google2.JPG';
import google3 from './posts/22-23/pictures/google3.JPG';
import google4 from './posts/22-23/pictures/google4.JPG';
import google5 from './posts/22-23/pictures/google5.JPG';
import google6 from './posts/22-23/pictures/google6.JPG';
import Fall22MM1group from './posts/22-23/pictures/Fall22MM1group.jpg';
import Fall22MM1talk from './posts/22-23/pictures/Fall22MM1talk.jpg';
import Fall22MM1wait from './posts/22-23/pictures/Fall22MM1wait.jpg';
import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'
import { Swiper, SwiperSlide} from "swiper/react";

//import reportWebVitals from './reportWebVitals';

const Blog = () => {
  const ref = useRef(null);

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="first-column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>WiC Blog!</b>
              </h3>
            </header>

            <div className="site-post">
              <h2>WiC Women in Faculty Highlight</h2>
              <p>
              On June 4, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Faculty"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x SWECC Origami Competition!</h2>
              <p>
              On June 3, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Origami"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Women in AI Collab Event</h2>
              <p>
              On May 22, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/WomenAI"> Read more... </Link>
              </p>
              <hr></hr>
            </div>


            <div className="site-post">
              <h2>WiC Alumni Networking Picnic</h2>
              <p>
              On May 21, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Alumni"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x Hiya Office Trek</h2>
              <p>
              On May 20, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Hiya"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x SWE Game Night</h2>
              <p>
              On May 7, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Game"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Annual Service Day!</h2>
              <p>
              On May 6, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Service"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC AP CSA Workshop Series</h2>
              <p>
              For two weeks, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/CSA"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x Clean Power Research Office Trek</h2>
              <p>
              On April 29th, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Clean"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x Trade Desk: Secrets to your Summer Internship</h2>
              <p>
              On April 16th, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Trade"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Phone Charms Decorating Event!</h2>
              <p>
              On April 17th, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Phone"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x WeLEAD: Women Trailblazers in Tech Event</h2>
              <p>
              On April 10th, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Trailblazer"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Cherry Blossoms LinkedIn Headshots!</h2>
              <p>
              On April 4th, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Cherry"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>International Womens Day Event 2025!</h2>
              <p>
              On March 5th, 2025, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Womens"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>COM^2 x Q++ x WiC Crochet Workshop</h2>
              <p>
              On Friday, February 21st WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Crochet"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Allen School Evening with Industry!</h2>
              <p>
              On Wednesday, February 19th, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Evening"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x cseed BuildHER Italian Soda Chats!</h2>
              <p>
              On Thursday, February 13th, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Buildher"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Early Career Hiya Panel!</h2>
              <p>
              On Monday, February 10th, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/HiyaX"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Roundtable Breakfast with Meta!</h2>
              <p>
              On Thursday, November 14th, WiC hosted...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Meta"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x GEN1 Ornament Night!</h2>
              <p>
              To celebrate the most wonderful time of the year, ... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Ornament"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Grace Hopper & Tapia Reflection Dinner!</h2>
              <p>
              On Tuesday, December 3rd, WiC hosted a Grace Hopper & Tapia Reflection ... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/GHCTapia"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Friendsgiving 2024!</h2>
              <p>
              On Tuesday, November 19th, we hosted our Friendsgiving celebration! ...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Friendsgiving"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">

             <h2>Meta Roundtable Breakfast!</h2>

             <p> On Thursday, November 14rd, WiC hosted a Open Networking & Breakfast ... </p> 

             <p> <Link className={'readMore'} to="/posts/24-25/Meta"> Read more...</Link> </p> 

             <hr></hr>

           </div> 

            <div className="site-post">
              <h2>WiC Speed Friending!</h2>
              <p>
              On Thursday, November 14th, WiC hosted our Speed Friending event! ... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Speed"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Open Networking & Lunch with Stripe!</h2>
              <p>
              On Wednesday, November 6th, WiC hosted our Lunch & Networking with Stripe event! ... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/Stripe24"> Read more... </Link>
              </p>
              <hr></hr>
            </div>
            
            <div className="site-post">
              <h2>First WiC Meeting of 2024-2025!</h2>
              <p>
              Last Thursday, we had our first WiC meeting of the 2024-2025 year! ... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/24-25/BobaKahoot"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Officer Board 2024-2025 Announcement</h2>
              <p>
              Thank you to everybody who supported and ran in this year’s elections... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/officer25"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Outreach Recap</h2>
              <p>
              The outreach team was happy to be part of the NCWiT award ceremony...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/outreach"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Service Day Recap</h2>
              <p>
              We collborated with a total of 9 other RSOs for for Service Day...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/serviceday"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Spring MM2: Potluck Brunch Recap</h2>
              <p>
              Last Friday we had our Potluck Brunch and we had so much fun with all of you...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/potluck"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

             <div className="site-post">
              <h2>Prepare for Summer and Fall with The Trade Desk Recap</h2>
              <p>
              Last Thursday, on May 16th, WiC hosted our ‘Preparing for the Summer and Fall’ event with The Trade Desk...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/ttd"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>PM Talks with Microsoft Recap</h2>
              <p>
              What an amazing evening with Microsoft PMs...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/pmtalks"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Multicultural Night with MiT Recap</h2>
              <p>
              Last Friday, we hosted a Multicultural Night with Minorities in Tech (MiT)...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/multiculturalnight"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC x cseed: Founders in Conversations - Yifan Zhang Recap</h2>
              <p>
              What a wonderful evening with the amazing Yifan Zhang...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/cseed"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Spring MM1: Ice Cream Social Recap</h2>
              <p>
              Thank you for coming to our first spring member meeting... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/icecream"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

          <div className="site-post">
            <h2>Percentage Project Photo Campaign</h2>
              <p>
              We worked with Percentage Project this quarter for a photo campaign...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/percentproject"> Read more... </Link>
              </p>
              <hr></hr>
          </div>

          <div className="site-post">
            <h2>International Women's Day Tabling Recap</h2>
              <p>
              WiC officers assemebled care packages to celebrate...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/women"> Read more... </Link>
              </p>
              <hr></hr>
          </div>

          <div className="site-post">
            <h2>Winter MM2: Tea Party Recap</h2>
              <p>
              WiC members gathered for a sophisticated Tea Party...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/teaparty"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

          <div className="site-post">
            <h2>Getting Stared with Tech Entrepreneurship Recap</h2>
              <p>
              WiC and WE Lead from the Buerk Center collaborated to host “Getting Started with Entrepreneurship.”...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/techentre"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

          <div className="site-post">
            <h2>Galentine's Day Tabling Recap</h2>
              <p>
              Thank you everyone who stopped by our Galentine’s Day tabling...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/galentines"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

          <div className="site-post">
            <h2>Winter MM1: Candle Painting and Charcuterie Boards Recap</h2>
              <p>
              On February 9th, WiC members gathered for a cozy Candle Painting...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/Candle"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
            <h2>Winter Affiliates Dinner Recap</h2>
              <p>
              Last Wednesday, we had our WiC Winter Affiliates Dinner...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/Wad"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Slumber Party with SWE Recap</h2>
              <p>
              On January 19th, WiC hosted a Slumber Party in collaboration with UW SWE...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/slumber"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>A December to Remember with GEN1 Recap</h2>
              <p>
              On December 1st, WiC hosted December to Remember, 
              a fun holiday social, in collaboration with UW GEN1...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/december"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Friendsgiving Recap</h2>
              <p>
              Thank you for coming to our Friendsgiving last Friday...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/friendsgiving"> Read more... </Link>
              </p>
              <hr></hr>
            </div>
            
            <div className="site-post">
              <h2>Grace Hopper Reflection Dinner Recap</h2>
              <p>
              Last week, we hosted our Grace Hopper Reflection Dinner 
              with those who attended the conference... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/gracehopperrecap"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Building Your Technical Career with Google Recap</h2>
              <p>
              We hosted a Building Your Technical Career with Google 
              event with two women engineers from Google...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/Googlerecap"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Women in Tech Panel with Pinterest Recap</h2>
              <p>
              We hosted a Pinterest Women in Tech Panel with two software engineers who are UW alums
               and one incoming software engineer currently at UW...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/Pinterest"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Uber Technical Interview Workshop Recap</h2>
              <p>
              We hosted an Uber Technical Interview Workshop with two women engineers from Uber’s Seattle
              office and provided Thai food for dinner...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/Uber"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Fall 2023 Member Meeting 1 Recap</h2>
              <p>
              Last Friday, we held our first Member Meeting of the school year! 
              We started the meeting off by introducing the club and officer team to our attendees...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/23-24/MM1"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>2023-24 Officer Election Results Announcement</h2>
              <p>
                Hi WiC members, Thank you to everybody who supported and ran in our 2022-2023 elections. We are excited to announce 
                the new officer board for next year...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/ElectionsResults"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Exploring Program Management Event Recap</h2>
              <p>
                On May 11th, WiC hosted our Exploring Program Management event to give WiC members the opportunity to learn about...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/PMTalk"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>2023-24 Officer Applications and Nominations Now Open!</h2>
              <p>
                Hi WiC members! Would you like to make an impact on gender diversity in computing? Do you like 
                event-planning and being involved in your... 
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/APPSNOMS23"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Spring Member Meeting Bouquet Making Recap</h2>
              <p>
                On April 19th, we held our first Member Meeting of Spring quarter which was a flower bouquet making event.
                WiC members got to...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/FLWR23"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Crack the Interview Event Recap</h2>
              <p>
                On April 16th, WiC hosted our “Crack the Interview” prep event to help students prepare for both behavioral
                and technical interviews...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/CTI23"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>WiC Swag Pre-Order Form Now Open</h2>
              <p>
                Hi WiC members!
                <br></br>
                Do you want to stay cozy while repping WiC? We are now offering branded quarter zip fleece jackets...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/Swag23"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Women in Research Panel Recap</h2>
              <p>
                On February 16th, WiC hosted our Women in Research Panel in conjunction with LEAP to promote women in academia. 
                It was...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/WIR23"> Read more... </Link>
              </p>
              <hr></hr>
            </div>

            <div className="site-post">
              <h2>Winter Career Prep Dinner Event Recap</h2>
              <p>
                On February 2nd, WiC held our Career Prep Dinner. It was a major success and we want to thank everyone
                who came! We had...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/WAD22"> Read more... </Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Racial Equity in Tech Event Recap</h2>
              <p>
                On January 17th, we held our Racial Equity in tech event in collaboration with Minorities in Tech!
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/Equity23"> Read more... </Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Member Meeting: Bowling Night Recap</h2>

              <p>
                On January 12th, we held our first Member Meeting of the quarter, a bowling night! We met...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/Bowling23"> Read more... </Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Confidence, Community, and Cookies Event Recap</h2>

              <p>
                On November 10th, we held our Confidence, Community, and Cookies event. We had the
                opportunity to discuss...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/Cookies22"> Read more... </Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Splunk Technical Interview Workshop & Meet Women Engineers at Google Event Recaps</h2>

              <p>
                Last week we put on two company events! For those of you who could not make it, here is a
                recap on all that we did...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/GoogleSplunk22Recap"> Read more... </Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>WiC Grace Hopper & Tapia Conference Reflection Event Recap</h2>

              <p>
                On Oct 26, we held our annual Grace Hopper and Tapia Conference
                Reflection! We started off by going over the...
              </p>
              <p>
              <Link className={'readMore'} to="/posts/22-23/GHCTapia22Recap">Read more...</Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>WiC Fall 2022 Member Meeting 1 Recap</h2>

              <p>
                Last week we held our first Member Meeting of the school year and quarter!
                We started the meeting off by introducing...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/Fall22MM1Recap">Read more...</Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Committee Applications Released</h2>

              <p>
                Looking for a great way to get involved in the Allen School and
                meet new people? Interested in building community and promoting
                inclusion in computing? Apply to join a WiC committee today!
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/comAppAnnounce">Read more...</Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Name Change Announcement</h2>

              <p>
                We are writing to announce that ACM-W is being renamed
                to Women in Computing at the University of Washington...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/nameChange">Read more...</Link>
              </p>
              <hr></hr>
            </div> 

            <div className="site-post">
              <h2>Fill Out The Rebranding Survey</h2>

              <p>
                ACM-W is rebranding and will no longer be affiliated with the
                larger ACM organization. We are interested in hearing input
                from Allen School...
              </p>
              <p>
                <Link className={'readMore'} to="/posts/22-23/RebrandSurvey22">Read more...</Link>
              </p>
              <hr></hr>
            </div> 
          </div> 
          <div className="second-column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>Snapshots</b>
              </h3>
            </header>
            <div className="image-columns"> 
             <div className="image-rows">
                <ImageCard imgsrc = {wad1}/>
                <ImageCard imgsrc = {wad2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {slumber2}/>
                <ImageCard imgsrc = {slumber6}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {dec1}/>
                <ImageCard imgsrc = {dec7}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {f1}/>
                <ImageCard imgsrc = {f3}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {ghc3}/>
                <ImageCard imgsrc = {ghc1}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {Googlerecap1}/>
                <ImageCard imgsrc = {Googlerecap6}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {Pinterest1}/>
                <ImageCard imgsrc = {Pinterest2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {Uberofficer}/>
                <ImageCard imgsrc = {Uberspeakers}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {MM1group}/>
                <ImageCard imgsrc = {MM1officer}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {PM1}/>
                <ImageCard imgsrc = {PM2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {PM3}/>
                <ImageCard imgsrc = {PM4}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {bouquet1}/>
                <ImageCard imgsrc = {bouquet2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {bouquet3}/>
                <ImageCard imgsrc = {bouquet4}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {bouquet5}/>
                <ImageCard imgsrc = {bouquet6}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {prep1}/>
                <ImageCard imgsrc = {prep2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {wir1}/>
                <ImageCard imgsrc = {wir2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {wir3}/>
                <ImageCard imgsrc = {wad}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {equity1}/>
                <ImageCard imgsrc = {equity2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {bowl1}/>
                <ImageCard imgsrc = {bowl2}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {bowl3}/>
                <ImageCard imgsrc = {cookies1}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {cookies2}/>
                <ImageCard imgsrc = {google1}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {google2}/>
                <ImageCard imgsrc = {google3}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {google4}/>
                <ImageCard imgsrc = {google5}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {google6}/>
                <ImageCard imgsrc = {Fall22MM1group}/>
              </div>
              <div className="image-rows">
                <ImageCard imgsrc = {Fall22MM1talk}/>
                <ImageCard imgsrc = {Fall22MM1wait}/>
              </div>
            </div>
          </div>
        </div>      
      </div>

      <div className='actions' ref={ref}>
      <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' class='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank'  class='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook/></a>
            <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Blog;


